import { DataSourceIDEnum } from '@/models/dataSource';
import { FC } from 'react';
import { DataSourceIconBaseProps } from './types';

import AmazonS3Icon from '@/assets/datasourcetypes/AMAZON_S3.svg?react';
import CsvFileIcon from '@/assets/datasourcetypes/CSV_FILE.svg?react';
import EncryptedCsvFileIcon from '@/assets/datasourcetypes/ENCRYPTED_CSV_FILE.svg?react';
import GoogleTagManagerIcon from '@/assets/datasourcetypes/GOOGLE_TAG_MANAGER.svg?react';
import SalesforceIcon from '@/assets/datasourcetypes/SALESFORCE.svg?react';
import SFTPIcon from '@/assets/datasourcetypes/SFTP.svg?react';
import WebsiteJSIcon from '@/assets/datasourcetypes/WEBSITE_JS.svg?react';
import WordPressIcon from '@/assets/datasourcetypes/WORDPRESS.svg?react';
import MicrosoftDynamics365Logo from '@/assets/icons/microsoft-dynamics-365-logo.svg?react';
import ShopifyLogo from '@/assets/icons/shopify-logo.svg?react';

export const DATA_SOURCE_ICONS: Record<DataSourceIDEnum, FC<DataSourceIconBaseProps>> = {
  [DataSourceIDEnum.WebsiteJS]: WebsiteJSIcon,
  [DataSourceIDEnum.WordPress]: WordPressIcon,
  [DataSourceIDEnum.EncryptedCsvFile]: EncryptedCsvFileIcon,
  [DataSourceIDEnum.CsvFile]: CsvFileIcon,
  [DataSourceIDEnum.GoogleTagManager]: GoogleTagManagerIcon,
  [DataSourceIDEnum.Salesforce]: SalesforceIcon,
  [DataSourceIDEnum.AmazonS3]: AmazonS3Icon,
  [DataSourceIDEnum.SFTP]: SFTPIcon,
  [DataSourceIDEnum.D365BusinessCentral]: MicrosoftDynamics365Logo,
  [DataSourceIDEnum.Shopify]: ShopifyLogo,
};
